import React from 'react'

import Widget from '../../Widget'
import WidgetBody from './WidgetBody'
import WidgetTitle from '../WidgetTitle'

const BadgeWidget: React.FC = () => {
  return (
    <Widget
      widgetTitle={<WidgetTitle title="Badges" />}
      widgetAriaLabel="Achievement Badges"
      widgetBody={<WidgetBody />}
      dataTestId="badges-widget"
    />
  )
}

export default BadgeWidget
